// extracted by mini-css-extract-plugin
export var productImage = "_nu-0";